const getFriendlyErrorMessage = (errors) => {
  let message = errors ? errors.message : '';
  let code = 0;

  if (errors && errors.graphQLErrors && errors.graphQLErrors[0] && errors.graphQLErrors[0].extensions && errors.graphQLErrors[0].extensions.exception) code = errors.graphQLErrors[0].extensions.exception.code;

  if (code && code === 11000) message = 'Duplicated key value (Ex: Title)';
  return `Action executed with error! Error message: ${message}`;
};
export { getFriendlyErrorMessage };
